import styled from 'styled-components';

const ProductsStyle = styled.section`
	--marginT: var(--sp9x);
	--gap: var(--sp6x);

	.wrapper-products {
		margin-top: var(--marginT);
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: var(--gap);
	}

	.wrapper-related-titles {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.styled-text {
		text-transform: lowercase;
	}

	.wrap-button {
		width: fit-content;
		height: fit-content;
		transform: scale(0);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--marginT: var(--sp8x);
		--gap: var(--sp4x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--marginT: var(--sp7x);
		--gap: var(--sp3x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--marginT: var(--sp6x);
		--gap: var(--sp2-5x);

		.tag-text {
			font-size: var(--p3);
		}
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--marginT: var(--sp5x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--marginT: var(--sp4x);
		--gap: var(--sp2x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--gap: var(--sp4x);

		.wrapper-products {
			grid-template-columns: 1fr;
			row-gap: var(--gap);
		}

		.wrapper-related-titles {
			flex-direction: column;
			align-items: start;
			gap: var(--sp3x);
		}
	}
`;

export default ProductsStyle;
